/**
 * 医保账目请求 api
 */
// 引入工具函数
import req from '@/utils/request';
/**
 * 结算相关接口 
 */
//获取所有结算，医疗，就诊凭证类型
export const getTypeListApi = (params) => {
        return req.get('/medical/settleDict', params);
    }
    // 获取医保结算列表
export const closeAccountListApi = (params) => {
        return req.post('/medical/settlePage', params);
    }
    // 获取结算详情
export const getSetlDetailsApi = (params) => {
        return req.get('/medical/settleDetail', params);
    }
    //结算统计信息
export const getCensusApi = (params) => {
    return req.post('/medical/settlePageCensus', params);
}

// 导出医保结算列表
export const downloadCloseAccountListApi = (params, customConfig) => {
        return req.downloadGet('/medical/settleExport', params, customConfig, 'application/vnd.ms-excel');
    }
    /**
     * 对账相关接口
     */
    // 获取医保对账列表
export const checkAccountListApi = (params) => {
        return req.post('/medical/checkBill', params);
    }
    // 获取医保对账明细
export const checkDetailAccountListApi = (params) => {
        return req.post('/medical/checkBillDetailPage', params);
    }
    //获取医保所有对账明细
export const checkDetailAccountAllListApi = (params) => {
        return req.post('/medical/checkBillDetailNonRefund', params);
    }
    //对账后更新数据
export const updateCheckListApi = (params) => {
        return req.post('/medical/updateBillCheck', params);
    }
    //对账日历信息
export const getCheckDateApi = (params) => {
  return req.post('/medical/getBillDay', params);
}
//异地对账后更新数据
export const updateCheckDiffListApi = (params) => {
  return req.post('/medical/updateBillCheckOffsite', params);
}
/**
 * 清算相关接口
 */
//清算列表
export const getClearAccountListApi = (params) => {
        return req.post('/medical/clearAccountList', params);
    }
    //清算后更新信息
export const updateClearApi = (params) => {
  return req.post('/medical/saveApplyClearId', params);
}

//获取历年数据
export const getYearDataApi = (params) => {
  return req.get('/yb_settle_data/ybDataConfig.json',params,'/st');
}

/**
 * 调医保相关接口
 */
//对总账
export const getCheckAccountTotalApi = (params) => {
        return req.yibaoPost('/account_checking', params);
    }
    //对明细
export const getCheckAccountDetailApi = (params) => {
        return req.yibaoPost('/account_checking_detail', params);
    }
    //清算
export const clearAccountApi = (params) => {
        return req.yibaoPost('/clear_settlement', params);
    }
    //撤销清算
export const cancelClearAccountApi = (params) => {
        return req.yibaoPost('/cancel_clear_settlement', params);
    }
    //冲正
export const reverseApi = (params) => {
        return req.yibaoPost('/reverse', params);
    }
    //查询费用明细
export const getDetailPayApi = (params) => {
        return req.yibaoPost('/query_settlement_info', params);
    }
    //查询就诊人明细
export const getDetailPsnApi = (params) => {
    return req.yibaoPost('/query_mdtrt_info', params);
}
//对异地明细账
export const diffAccountCheckingDetailApi = (params) => {
  return req.yibaoPost('/diff_account_checking_detail', params);
}
//清算异地
export const diffClearSettlementApi = (params) => {
  return req.yibaoPost('/diff_clear_settlement ', params);
}
